import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { UnitValue } from 'src/app/form-controls/unit-value/unit-value.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { OxygenActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface OxygenActionFormGroup {
	percentageGiven: FormControl<UnitValue | null>;
}

@Component({
    selector: 'app-oxygen-action-controls-v2',
    templateUrl: './oxygen-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './oxygen-action-controls-v2.component.scss'],
    imports: [CommonActionControlsComponent, ActionFormComponent, UnitQuantityControl, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OxygenActionControlsComponentV2 implements SheetActionControlsBase {

	slot!: Slot | null;
	action!: OxygenActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as OxygenActionV2;
	}

	@Input() form!: FormGroup<OxygenActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

  	ngOnInit(): void {
      	this.form.addControl('percentageGiven', this.formBuilder.control(this.action?.percentageGiven ?? null));
  	}
}
